import { studentsConstants } from './constants';
// import { authConstants } from '../auth/constants';

import pdfMake from 'pdfmake/build/pdfmake';
import vfsFonts from 'pdfmake/build/vfs_fonts';


var viewActions = require ('../../store/view.actions');

var studentService = require ('./api');

const components = require('./reports/components') ;


var attendanceService = require('../courses/apis/attendanceApi');
var sdf = require('date-format');

export const studentActions = {
   getStudentBrief, getCertificadoEgreso,
   getMyEvaluations, getCourseEvaluations,
   getStudentAttendance, addStudentAttendanceAdjustment, deleteStudentAttendance
};  

function getCertificadoEgreso ( student, fechaEgreso ) {
              let dniFormated = student.persona.doc_nbr.substring(0,2) + "." + student.persona.doc_nbr.substring(2,5) + 
                                    "." + student.persona.doc_nbr.substring(5,8)
              student.persona.dniFormated = dniFormated ;
              let {vfs} = vfsFonts.pdfMake;
              pdfMake.vfs = vfs;
              const documentDefinition = {
                // watermark: {text: 'BORRADOR', color: 'blue', opacity: 0.3, bold: true, italics: false},
                pageOrientation: 'landscape',
                content: [
                  {
                    table: {
                      body: [[{
                        stack: [
                          components.header (student),
                          components.contentBody( student, fechaEgreso ),
                          components.signatures,
                          components.footer,
                        ]
                      }]]
                    },
                    layout: {
                      //set custom borders size and color
                      hLineWidth: function (i, node) {
                        return (i === 0 || i === node.table.body.length) ? 2 : 1;
                      },
                      vLineWidth: function (i, node) {
                        return (i === 0 || i === node.table.widths.length) ? 2 : 1;
                      },
                      hLineColor: function (i, node) {
                        return (i === 0 || i === node.table.body.length) ? 'black' : 'gray';
                      },
                      vLineColor: function (i, node) {
                        return (i === 0 || i === node.table.widths.length) ? 'black' : 'gray';
                      },
                      paddingLeft: function (i) {
                        return i === 0 ? 10 : 8;
                      },
                      paddingRight: function (i, node) {
                        return (i === node.table.widths.length - 1) ? 10 : 8;
                      }
                    }
                  }
                  
                ],
                styles: components.styles
               }
              pdfMake.createPdf(documentDefinition).open();
 
}




function getStudentBrief( token, studentID, calendarID ) { 
  return dispatch => {
         
          dispatch(viewActions.isLoadingModule('getStudentBrief',true)) ;
          studentService.getStudentBrief( token, studentID, calendarID )
          .then( json => {
              if (json.persona.birthdate) json.persona.birthdate = json.persona.birthdate.replace('Z','')
              dispatch(showStudent( json ))
              dispatch(viewActions.isLoadingModule('getStudentBrief',false) )
          } )
          
  }
}

function  getCourseEvaluations ( token, studentCourseID ) { 
  return dispatch => {
         
          dispatch(viewActions.isLoadingModule('getCourseEvaluations',true)) ;
          studentService.getCourseEvaluations( token, studentCourseID  )
          .then( json => {
              dispatch({
                type: studentsConstants.COURSE_EVALUATIONS,
                courseEvaluations: json
              })  
            
              dispatch(viewActions.isLoadingModule('getCourseEvaluations',false) )
          } )
          
  }
}

function  getStudentAttendance ( token, studentID, calendarID ) { 
  return dispatch => {
         
          dispatch(viewActions.isLoadingModule('getStudentAttendance',true)) ;
          studentService.getStudentAttendance( token,  studentID, calendarID )
          .then( json => {
              dispatch({
                type: studentsConstants.STUDENT_ATTENDANCE,
                studentAttendance: json
              })  
            
              dispatch(viewActions.isLoadingModule('getStudentAttendance',false) )
          } )
          
  }
}

function addStudentAttendanceAdjustment(token, studentID, calendarID, qty, ajuType) {
  return dispatch => {
    dispatch(viewActions.isLoadingModule('postStudentAttendance', true));

    const data = {
      date: sdf.asString('yyyy-MM-dd', new Date()),
      attendance_type: 'AJU',
      description: (ajuType && ajuType.description) || 'Ajuste',
      qty: qty,
      justified: '',
      justification_required: (ajuType && ajuType.justification) || 'N',
    };

    return attendanceService.postAttendance(token, studentID, calendarID, data)
      .then(() => studentService.getStudentAttendance(token, studentID, calendarID))
      .then((json) => {
        dispatch({
          type: studentsConstants.STUDENT_ATTENDANCE,
          studentAttendance: json,
        });
        dispatch(viewActions.isLoadingModule('postStudentAttendance', false));
      })
      .catch(() => {
        dispatch(viewActions.isLoadingModule('postStudentAttendance', false));
      });
  };
}

function deleteStudentAttendance(token, studentID, calendarID, attendanceID) {
  return dispatch => {
    dispatch(viewActions.isLoadingModule('deleteStudentAttendance', true));

    return attendanceService.deleteAttendance(token, studentID, attendanceID)
      .then(() => studentService.getStudentAttendance(token, studentID, calendarID))
      .then((json) => {
        dispatch({
          type: studentsConstants.STUDENT_ATTENDANCE,
          studentAttendance: json,
        });
        dispatch(viewActions.isLoadingModule('deleteStudentAttendance', false));
      })
      .catch(() => {
        dispatch(viewActions.isLoadingModule('deleteStudentAttendance', false));
      });
  };
}

function  getMyEvaluations ( token, calendarID ) { 
  return dispatch => {
         
          dispatch(viewActions.isLoadingModule('getMyEvaluations',true)) ;
          studentService.getMyEvaluations( token, calendarID )
          .then( json => {
              dispatch({
                type: studentsConstants.MY_EVALUATIONS,
                myEvaluations: json
              })  
            
              dispatch(viewActions.isLoadingModule('getMyEvaluations',false) )
          } )
          
  }
}

function showStudent(json) {
  return { 
    type: studentsConstants.SHOW_STUDENT,
    student: json
  }
}
